/*

rajesh 09/19/2022  2698948956 Fixed GAL (136,137,158,98) and field group table GAL-153
sohel  09/26/2022  2698948956 Custom Windows -> Added Window Owner Field, columns to dashboard table bugfixes.
ashraf 09/29/2022  2698948956 fixed style issues in custom windows
ashraf 09/29/2022  2698948956 fixed bugs on add custom window
usha   09/29/2022  2698948956 Customization in custom window
ashraf 09/30/2022  2698948956 fixed copy window issue
ashraf 09/30/2022  2698948956 fixed ssn and phone format bugs
ashraf 10/06/2022  2698948956 added comments to code, removed unusual code
ashraf 10/06/2022  2698948956 fixed page break issue in role data
ashraf 10/07/2022  2698948956 removed commented code
ashraf 10/15/2022  2698948956 Added custom windows code comments
suresh peddavoora 10/27/2022 2698948956 Added outlined icons and  Class Name for Table
ashraf 10/27/2022  2698948956 custom window UX changes
ashraf 10/29/2022 2698948956 added search bar to table
lalitha 11/01/2022 2698948956 added span element in column link
saikrishna 11/03/2022 2698948956 Changed pagination options
Ashraf 11/08/2022 2698948956 added field json validator in initialvalues
Ashraf 11/15/2022 2698948956 Fixed toast message disappear
Ashraf 11/28/2022 2698948956 changed Api for custom window search
Ashraf 11/28/2022 2698948956 passing search data in table Api payload
Gummala Prakash 11/29/2022 2698948956 Fixed Field Table column and Table Footer.
Ashraf 12/01/2022 2698947782 removed indicator field.
Ashraf 12/01/2022 2698947782 reset table data after delete.
Ashraf 12/01/2022 2698947782 enabled copy functionality.
Ashraf 12/01/2022 2698947782 enabled edit icon to edit custom window
Dilip 12/05/2022 2698947782 removed unnecessary console.log statements
akhila 12/07/2022 2698947782 added default value for createdFor
Ashraf 12/07/2022 2698947782 fixed loader issue
lalitha 12/07/2022 2698947782 added Created By payload
Ashraf 12/08/2022 2698947782 fetching window data by Id
akhila 12/08/2022  2698947782 adding session storage for search items
kavya9reddy 12/09/2022 2698947782 Added createdDate in  payload
Ashraf 12/12/2022 2698947782 fixed role based access in custom windows
akhila 12/12/2022 2698947782 integrated download configuration api
akhila 12/12/2022 2698947782 fixed CreatedFor issue
dilip 12/13/2022 2698947782 Fixed page break issue while searching
Ashraf 12/14/2022 2698947782 fixed role based access
kavyareddy 12/14/2022 2698947782 Changed the payload in print
Suresh peddavoora 12/20/2022 2698947782 Fixed Button alignments
Dilip 02/13/2023 2698947782 created by , creted for pauload changes
Ravi 02//23/2023 2698947782 Added popup in download configuration button.
suresh peddavoora 02/24/2023 2698947782 New UI changes added
Ravi 03/01/2023 2698947782 Added loader and download toast message for preview File
Prakash 03/16/2023 2698947782 Added Custom Action-Icons.
suresh peddavoora 03/16/2023 2698947782 Toolbar button Alignments
suresh peddavoora 04/03/2023 2698947782 add icon added
Ravi 05/31/2023 2698947782 changed delete popup message
Sohel 06/01/2023 4136387705 Added module Name in payload
Akhila 06/08/2023 4136387705 created date change to date created field and column
uday 10/03/2023 4136387705 fixed table alignemts issues
*/

import React, {useEffect, useState, useRef} from 'react';
// import MaterialTable from "material-table";
import {fetchUDW} from '../../redux/reducers/UDW/UdwWindows';
import {tableIcons} from '../../components/TableIcons';
import {Button, makeStyles, TablePagination} from '@material-ui/core';
import {useSelector, useDispatch} from 'react-redux';
import {tablePageRows, defaultRows} from '../../constants/ReusableConstants';
import {ErrorSnackbar, SuccessSnackbar} from '../../components/CustomSnackBar';
import {resetDownloadMsg} from '../../redux/reducers/PreviewFileData';
import {
  resetUdwStatus,
  resetWindowData,
  fetchCustomWindowData,
  resetToast,
  getUDW,
  WindowDeletion as windowDeletion,
} from '../../redux/reducers/UserDefinedWindow';
import DeleteTableRecordPopup from '../../util/DeleteTableRecordPopup';
import {
  postCustomWindows,
  resetUDWPrintStatus,
  resetConfigUrl,
  resetDockey,
} from '../../redux/reducers/UDW/UDWlookup';
import GuiTable from '../FormComponents/GuiTable';
import {httpPaginationPost} from '../../util/Rest';

import moment from 'moment';
import {useUpdateEffect} from 'react-use';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
} from '../../redux/reducers/ReportMaster';
import {downloadButton} from '../../util/Content';
import PreviewFileDialog from '../../util/PreviewFileDialog';
import axios from 'axios';
import PageLoader from '../PageLoader';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../src/util/ActionMenuItem';
import AddIcon from '@material-ui/icons/AddOutlined';
import {MTableToolbar} from 'material-table';

const useStyles = makeStyles((theme) => ({
  link: {
    color: '#320469 !important',
  },
  buttonRoot: {
    'lineHeight': 1.75,
    [theme.breakpoints.down('md')]: {
      lineHeight: 1.5,
      padding: '6px 15px',
    },
    '& .MuiButton-label': {
      fontSize: '0.813rem',
      [theme.breakpoints.down('md')]: {
        fontSize: '0.688rem',
        letterSpacing: 1,
      },
    },
  },
}));
const UserDefinedWindows = ({
  UDWData,
  setWindowNumber,
  setIsCopyRowData,
  setEditExisting,
  setInitialValues,
  setFormData,
  changedWindowNumber,
  setChangedWindowNumber,
  setValue,
  setSubmit,
  submit,
  searchData,
}) => {
  useEffect(() => {
    submit && tableData?.current?.onQueryChange();
  }, [submit]);

  const dispatch = useDispatch();
  const classes = useStyles();
  const {isLoading: udwFetchLoading} = useSelector(({udwWindows}) => udwWindows);
  const {lookupUDWerrorMsg, successMsg, configurationUrl, dockey} = useSelector(
    ({udwLookup}) => udwLookup,
  );

  const {roleData} = useSelector(({role}) => role);
  const [rows, setRows] = useState(defaultRows);
  const tableData = useRef();

  const {
    udwStatus,
    errorMsg,
    WindowDeletesuccessMsg,
    windowDeleteStatus,
    windowDeletionLoading,
    windowValidationDeleteStatus,
  } = useSelector(({userDefinedWindow}) => userDefinedWindow);

  const {WindowStatus} = useSelector(({udwLookup}) => udwLookup);
  const [dialogOpen, setDialogOpen] = useState('');
  const [deleteWindowData, setDeleteWindow] = useState('');
  const [arrayLast, setArrayLast] = useState(false);
  const [dataCount, setDataCount] = useState('');
  const [order, setOrder] = useState({});
  const [configOpen, setConfigOpen] = useState(false);
  const [isLoadingPrint, setIsLoadingPrint] = useState(false);
  const [configData, setConfigData] = useState(null);
  const user = JSON.parse(sessionStorage.getItem('userDetails'));
  // fetch all window data (2698948956)
  useEffect(() => {
    dispatch(resetWindowData());
    setInitialValues({
      type: 'none',
      windowCode: '',
      description: '',
      viewOnly: false,
      header: '',
      indicator: '',
      windowOwner: '',
      jsonValidator: '',
      createdFor: {userLoginName: user?.userName},
      category: '',
      fieldHeader: '',
      viewOnlyField: '',
      orderBy: [],
      groupBy: [],
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      dispatch(resetToast());
    }, 4000);
  }, [errorMsg]);

  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingPrint(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingPrint(false);
      }
      readData();
    }
  }, [configurationUrl]);
  // reset redux print state after successfully downloaded (2698948956)
  useEffect(() => {
    if (WindowStatus && WindowStatus === 200) {
      setTimeout(() => {
        dispatch(resetUDWPrintStatus());
      }, 3000);
    }
  }, [WindowStatus]);

  // reset delete validation status in redux after use (2698948956)
  useEffect(() => {
    if (windowValidationDeleteStatus && windowValidationDeleteStatus === 200) {
      setDialogOpen(true);
      setTimeout(() => {
        dispatch(resetUdwStatus());
      }, 3000);
    }
  }, [windowValidationDeleteStatus]);

  // reset data and fetch windows after successful deletion of window (2698948956)
  useEffect(() => {
    if (WindowDeletesuccessMsg) {
      if (windowDeleteStatus === 200) {
        setIsCopyRowData(false);
        setWindowNumber(false);
        setInitialValues({
          type: 'none',
          windowCode: '',
          description: '',
          viewOnly: false,
          header: '',
          indicator: '',
          windowOwner: '',
          jsonValidator: '',
          createdFor: '',
          category: '',
          fieldHeader: '',
          viewOnlyField: '',
          orderBy: [],
          groupBy: [],
          orderDirection: 'asc',
        });
        tableData?.current?.onQueryChange();
      }
      setTimeout(() => {
        dispatch(resetUdwStatus());
        dispatch(resetToast());
      }, 2500);
    }
  }, [errorMsg, WindowDeletesuccessMsg]);

  useUpdateEffect(() => {
    if (WindowDeletesuccessMsg || udwStatus) {
      dispatch(fetchCreatedForDropDownData('customwindow'));
      dispatch(fetchCreatedByDropDownData('customwindow'));
    }
  }, [udwStatus, WindowDeletesuccessMsg]);

  // checking validation for deletion of window (2698948956)
  const handleDelete = (rowData) => {
    // dispatch(WindowValidationDeletion(rowData));
    // setDeleteWindow(rowData);
    setDeleteWindow(rowData);
    setDialogOpen(true);
  };

  // to close dialog box (2698948956)
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  // deleting a window (2698948956)
  const handleDeleteSubmission = () => {
    dispatch(windowDeletion(deleteWindowData));
    handleDialogClose();
  };

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  const handleEdit = (rowData) => {
    dispatch(getUDW(rowData?.windowId));
    dispatch(fetchCustomWindowData(rowData?.windowId));
    setIsCopyRowData(false);
    setValue(1);
    // setWindowNumber(rowData.windowCode);
    // setChangedWindowNumber(!changedWindowNumber);
    setEditExisting(true);
  };
  const handleCopy = (rowData) => {
    setIsCopyRowData(true);
    dispatch(fetchCustomWindowData(rowData?.windowId));
    setValue(1);
    setEditExisting(false);
    // setWindowNumber(rowData?.windowCode);
    // setChangedWindowNumber(!changedWindowNumber);
  };
  // fetch all windows after successful data post (2698948956)
  useEffect(() => {
    if (udwStatus === 200) {
      dispatch(fetchUDW());
    }
  }, [udwStatus]);

  // table columns (2698948956)
  const columns = [
    {
      title: 'Category',
      field: 'category',
      maxWidth: '130px',
      minWidth: '129px',
      render: (rowData) => {
        return rowData?.category === 'CL' ?
          'CL - Client' :
          rowData?.category === 'CO' ?
            'CO - Core' :
            rowData?.category === 'PA' ?
              'PA - Payment' :
              '';
      },
    },
    {
      title: 'Window Name',
      field: 'windowName',
      minWidth: '200px',
      maxWidth: 201,
      render: (rowData) => {
        return (
          <span
            role="button"
            className={`table-word-wrap-border ${classes.link}`}
            onClick={() => {
              dispatch(getUDW(rowData?.windowId));
              dispatch(fetchCustomWindowData(rowData?.windowId));
              setIsCopyRowData(false);
              setValue(1);
              // setWindowNumber(rowData.windowCode);
              // setChangedWindowNumber(!changedWindowNumber);
              setEditExisting(true);
            }}
          >
            {rowData?.windowName?.replace(/ /g, '\u00a0')}
          </span>
        );
      },
    },
    {
      title: 'Window Description',
      field: 'windowDescription',
      maxWidth: '300px',
      minWidth: '299px',
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 300,
              // textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.windowDescription?.replace(/ /g, '\u00a0')}
          </div>
        </>
      ),
    },
    {
      title: 'Created For',
      field: 'createdFor',
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    // {
    //   title: "Type",
    //   field: "type",
    //   maxWidth: 80,
    // },
    // {
    //   title: "Window Code",
    //   field: "windowCode",
    //   maxWidth: 120,
    //   render: (rowData) => {
    //     return (
    //       <span
    //         role="button"
    //         className={classes.link}
    //         onClick={() => {
    //           setIsCopyRowData(false);
    //           setValue(1);
    //           setWindowNumber(rowData.windowCode);
    //           setChangedWindowNumber(!changedWindowNumber);
    //           setEditExisting(true);
    //         }}
    //       >
    //         {rowData.windowCode}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   title: "Window Name",
    //   field: "header",
    //   maxWidth: 170,
    //   render: (rowData) => (
    //     <>
    //       <div
    //         style={{
    //           maxWidth: 170,
    //           whiteSpace: "normal",
    //           wordWrap: "break-word",
    //         }}
    //       >
    //         {rowData.header}
    //       </div>
    //     </>
    //   ),
    // },
    // {
    //   title: "Description",
    //   field: "description",
    //   render: (rowData) => (
    //     <>
    //       <div
    //         style={{
    //           // maxWidth: 800,
    //           whiteSpace: "normal",
    //           wordWrap: "break-word",
    //         }}
    //       >
    //         {rowData.description}
    //       </div>
    //     </>
    //   ),
    // },
    // {
    //   title: "Indicator",
    //   field: "indicator",
    //   maxWidth: 120,
    // },
    // {
    //   title: "View Only",
    //   field: "isView",
    //   maxWidth: 100,
    // },
    // {
    //   title:"Window Owner",
    //   field:"windowOwner",
    // },
    // {
    //   title:"Created By",
    //   field:"createdBy",
    // },
    // {
    //   title:"Created Date",
    //   field:"createdDate",
    // },
  ];

  // handling download of windows data (2698948956)
  const handlePrintData = () => {
    const data = tableData.current?.state?.data;
    if (data?.length > 0) {
      dispatch(
        postCustomWindows({
          category: searchData?.category?.categoryCode ? searchData?.category?.categoryCode : '',
          createdBy: searchData?.createdBy?.userLoginName ?
            searchData?.createdBy?.userLoginName :
            '',
          createdFor: searchData?.createdFor?.userLoginName ?
            searchData?.createdFor?.userLoginName :
            '',
          createdDate: searchData?.createdDate ?
            moment(searchData?.createdDate).format('MM/DD/YYYY') :
            '',
          orderBy: order?.orderBy ? order?.orderBy : '',
          orderDirection: order?.orderDirection ? order?.orderDirection : '',
          windowDescription: searchData?.windowDescription ? searchData?.windowDescription : '',
          windowIndicator: searchData?.indicator ? searchData?.indicator : '',
          windowName: searchData?.windowName ? searchData?.windowName : '',
        }),
      );
      setIsLoadingPrint(false);
    }
  };
  const SearchSessionCustomWindows = JSON.parse(sessionStorage.getItem('CustomWindows'));
  if (SearchSessionCustomWindows && !submit) {
    searchData = SearchSessionCustomWindows;
  }
  return (
    <>
      <DeleteTableRecordPopup
        open={Boolean(dialogOpen)}
        dialogClose={handleDialogClose}
        title="Delete Custom Window"
        value={`Are you sure you want to delete the ${deleteWindowData?.windowName?.replace(/ /g, '\u00a0')} -
         ${deleteWindowData?.windowDescription?.replace(/ /g, '\u00a0')} Custom Window?`}
        handleSubmit={handleDeleteSubmission}
      />
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Custom Windows'}
      />
      <div className="custom-table actions-dropdown-table custom-actions-icon custom-toolbar-icons global-field-table mt-2 new-standard-textfields tablescroll-block">
        <GuiTable
          icons={tableIcons}
          title=""
          columns={columns}
          tableRef={tableData}
          isLoading={windowDeletionLoading || udwFetchLoading}
          data={(query) =>
            new Promise((resolve) => {
              const url = `custom/window/search/custom-window`;
              const bodyObj = {
                category: searchData?.category?.categoryCode ?
                  searchData?.category?.categoryCode :
                  '',
                createdFor: searchData?.createdFor?.userLoginName ?
                  searchData?.createdFor?.userLoginName :
                  '',
                createdDate: searchData?.createdDate ?
                  moment(searchData?.createdDate).format('MM/DD/YYYY') :
                  '',
                windowDescription: searchData?.windowDescription ?
                  searchData?.windowDescription :
                  '',
                windowIndicator: searchData?.indicator ? searchData?.indicator : '',
                windowName: searchData?.windowName ? searchData?.windowName : '',
                limit: query.pageSize ? query.pageSize : null,
                orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                orderDirection: query?.orderDirection ? query?.orderDirection : '',
                createdBy: searchData?.createdBy?.userLoginName ?
                  searchData?.createdBy?.userLoginName :
                  '',
                page: submit ?
                  1 :
                  arrayLast && query?.page >= 1 ?
                    query.page :
                    arrayLast ?
                      (query.page <= 1 && query.page + 1) || query.page - 1 :
                      query.page + 1,
              };
              setOrder({
                orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                orderDirection: query?.orderDirection ? query?.orderDirection : '',
              });
              httpPaginationPost(url, bodyObj)
                .then((response) => {
                  if (response?.status === 200) {
                    const data = response.data.response.resultObject;
                    resolve({
                      data: data.length > 0 ? data : [],
                      page: response.data.response.page - 1,
                      totalCount: response.data.response.count,
                    });
                    setSubmit(false);
                    setDataCount(response.data.response.count);
                    setArrayLast(response.data.response.resultObject.length === 1);
                    tableData.current.dataManager['orderBy'] =
                      query?.orderBy?.tableData?.columnOrder;
                    tableData.current.dataManager['orderDirection'] = query?.orderDirection;
                  } else {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  }
                })
                .catch((response) => {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                  dispatch({
                    type: 'FETCH_ERROR',
                    payload: response && response.message ? response.message : null,
                  });
                });
            })
          }
          options={{
            search: false,
            pageSizeOptions: tablePageRows,
            pageSize: rows,
            emptyRowsWhenPaging: false,
            toolbarButtonAlignment: 'left',
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          actions={[
            // {
            //   icon: () => (
            //     <>
            //       <Button disabled={!roleData?.window?.["Custom Window Setup"]?.CWS?.add} type="button" variant="outlined" className={`search-btn`}>
            //         Add Window
            //       </Button>
            //     </>
            //   ),
            //   disabled: !roleData?.window?.["Custom Window Setup"]?.CWS?.add,
            //   isFreeAction: true,
            //   onClick: (event) => {
            //     setValue(1);
            //   },
            // },
            // (rowData) => ({
            //   icon: () => <EditOutlinedIcon />,
            //   tooltip: "Edit",
            //   disabled: !roleData?.window?.["Custom Window Setup"]?.CWS?.edit,
            //   onClick: (event, rowData) => {
            //     dispatch(getUDW(rowData?.windowId));
            //     dispatch(fetchCustomWindowData(rowData?.windowId));
            //     setIsCopyRowData(false);
            //     setValue(1);
            //     // setWindowNumber(rowData.windowCode);
            //     // setChangedWindowNumber(!changedWindowNumber);
            //     setEditExisting(true);
            //   },
            // }),
            // {
            //   icon: () => <FileCopyOutlinedIcon />,
            //   tooltip: "Copy",
            //   disabled: !roleData?.window?.["Custom Window Setup"]?.CWS?.add,
            //   onClick: (event, rowData) => {
            //     setIsCopyRowData(true);
            //     dispatch(fetchCustomWindowData(rowData?.windowId));
            //     setValue(1);
            //     setEditExisting(false);
            //     // setWindowNumber(rowData?.windowCode);
            //     // setChangedWindowNumber(!changedWindowNumber);
            //   },
            // },
            // (rowData) => ({
            //   // delete a window (2792000392)
            //   icon: () => <DeleteOutlineOutlinedIcon />,
            //   tooltip: "Delete",
            //   // disabling delete if that window doesn't have id generated in db or doesn't have access to delete (2792000392)
            //   disabled: !rowData?.windowId || !roleData?.window?.["Custom Window Setup"]?.CWS?.delete,
            //   onClick: (event, rowData) => {
            //     setDeleteWindow(rowData);
            //     setDialogOpen(true);
            //   },
            // }),
            {
              icon: () => <SaveIcon />,
              tooltip: 'Save User',
              onClick: (event, rowData) => console.log(rowData, 'rowData'),
            },
          ]}
          components={{
            Pagination: (props) => (
              <div className="global-field-table-footer ">
                <div className="mt-2">
                  <Button
                    type="button"
                    variant="outlined"
                    className={`mx-1 search-btn`}
                    disabled={Boolean(dataCount === 0)}
                    // tooltip: "Print",
                    // isFreeAction: true,
                    onClick={() => {
                      handlePrintData(), setIsLoadingPrint(true);
                    }}
                  >
                    {downloadButton}
                  </Button>
                </div>
                <div>
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              </div>
            ),
            Action: (props) => (
              <ActionMenuItem
                {...props}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                handleCopy={handleCopy}
                hiddenMenu={{
                  edit: false,
                  copy: false,
                  notes: true,
                  hiddenDelete: false,
                  execution: true,
                  run: true,
                  usage: true,
                  user: true,
                  password: true,
                  test: true,
                }}
                disableMenu={{
                  disableEdit: !roleData?.window?.['Custom Window Setup']?.CWS?.edit,
                  disableCopy: !roleData?.window?.['Custom Window Setup']?.CWS?.add,
                  disableNotes: false,
                  disableUsage: false,
                  disableUser: false,
                  disablePassword: false,
                  disableRun: false,
                  disableDelete:
                    !props?.data?.windowId ||
                    !roleData?.window?.['Custom Window Setup']?.CWS?.delete,
                  disableExecution: false,
                  disableTest: false,
                }}
              />
            ),
            Toolbar: (props) => (
              <div>
                <MTableToolbar {...props} />
                <div>
                  {
                    <Button
                      disabled={!roleData?.window?.['Custom Window Setup']?.CWS?.add}
                      type="button"
                      variant="outlined"
                      className={`search-btn`}
                      isFreeAction={true}
                      onClick={(event) => {
                        setValue(1);
                      }}
                      startIcon={<AddIcon />}
                    >
                      Add Window
                    </Button>
                  }
                </div>
              </div>
            ),
          }}
          onSelectionChange={(rows) => rows}
        />
      </div>
      {isLoadingPrint && <PageLoader />}
      {(lookupUDWerrorMsg || errorMsg) && (
        <ErrorSnackbar errorMsg={lookupUDWerrorMsg || errorMsg} />
      )}
      {(WindowDeletesuccessMsg || successMsg) && (
        <SuccessSnackbar successMsg={WindowDeletesuccessMsg || successMsg} />
      )}
    </>
  );
};

export default UserDefinedWindows;
